export default "__VITE_ASSET__f9ea4c78__"